module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/endosig/endosig.component.html
// module id = ./src/app/endosig/endosig.component.html
// module chunks = main